import { render, staticRenderFns } from "./PgaCancelButton.vue?vue&type=template&id=3058a7b0&"
import script from "./PgaCancelButton.vue?vue&type=script&lang=ts&"
export * from "./PgaCancelButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3058a7b0')) {
      api.createRecord('3058a7b0', component.options)
    } else {
      api.reload('3058a7b0', component.options)
    }
    module.hot.accept("./PgaCancelButton.vue?vue&type=template&id=3058a7b0&", function () {
      api.rerender('3058a7b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/PgaCancelButton.vue"
export default component.exports